(function () {
  function markLoaded(img) {
    if (!img.classList.contains('fade-image')) return;
    // ensure a paint before flipping to loaded so transition actually runs
    requestAnimationFrame(() => {
      img.classList.add('is-loaded');
    });
  }

  function wireImage(img) {
    if (!img || img._fadeWired) return;
    img._fadeWired = true;

    if (img.complete && img.naturalWidth > 0) {
      // cached/instant: mark on next frame (so transition happens)
      markLoaded(img);
    } else {
      img.addEventListener('load', () => markLoaded(img), { once: true });
      img.addEventListener('error', () => markLoaded(img), { once: true }); // fail-safe
    }
  }

  function initScope(root) {
    (root || document).querySelectorAll('img.fade-image').forEach(wireImage);
  }

  // initial + dynamic (same as before)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScope(document));
  } else {
    initScope(document);
  }

  const mo = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('img.fade-image')) wireImage(node);
        const imgs = node.querySelectorAll?.('img.fade-image');
        if (imgs?.length) imgs.forEach(wireImage);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (e) => initScope(e.target));
  document.addEventListener('shopify:section:select', (e) => initScope(e.target));

  window.__fadeImageInit = initScope;
})();
